<template>
  <v-card elevation="2" height="52" class="mb-2" :loading="isUploading">
    <template slot="progress">
      <v-progress-linear indeterminate top absolute></v-progress-linear>
    </template>

    <div class="d-flex justify-space-between align-center pa-3 ">
      <div class="d-flex align-center attachment-card__filename">
        <v-icon class="mr-2" size="40" color="blue-grey">{{ fileIcon }}</v-icon>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              class="cursor-default"
              v-on="on"
              v-bind="attrs"
              :title="filename"
              >{{ filenameLabel }}</span
            >
          </template>

          <span>{{ filename }}</span>
        </v-tooltip>
      </div>

      <div
        v-if="!isUploading"
        class="d-flex align-center attachment-card__actions"
        :class="{
          'justify-space-between': isEditMode,
          'justify-end': !isEditMode,
        }"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <Button
              color="grey"
              icon="mdi-download"
              size="small"
              v-on="on"
              v-bind="attrs"
              @click="$emit('download')"
            />
          </template>

          <span>{{ $t('common.button.download') }}</span>
        </v-tooltip>

        <v-tooltip v-if="isEditMode" top>
          <template v-slot:activator="{ on, attrs }">
            <Button
              v-on="on"
              v-bind="attrs"
              color="grey"
              icon="mdi-delete-outline"
              size="small"
              @click="$emit('delete')"
            />
          </template>

          <span>{{ $t('common.button.delete') }}</span>
        </v-tooltip>
      </div>
    </div>
  </v-card>
</template>

<script>
const MAX_FILENAME_CHARACTERS = 30
import Button from '@/components/UI/Button'
import mixin from '@/mixins/mixin.vue'

export default {
  mixins: [mixin],

  props: {
    filename: {
      type: String,
      required: true,
    },

    isUploading: {
      type: Boolean,
      required: false,
    },

    isEditMode: {
      type: Boolean,
      required: false,
    },
  },

  components: { Button },

  computed: {
    filenameLabel() {
      if (this.filename.length <= MAX_FILENAME_CHARACTERS) return this.filename

      const firstSubstrTotalChars = MAX_FILENAME_CHARACTERS / 2
      const secondSubstrTotalChars = firstSubstrTotalChars - 1
      const secondSubstrStart = this.filename.length - secondSubstrTotalChars

      return `${this.filename.substr(
        0,
        firstSubstrTotalChars
      )}...${this.filename.substr(secondSubstrStart, this.filename.length)}`
    },

    fileIcon() {
      return this.getFileIconByExtension(this.filename)
    },
  },
}
</script>

<style lang="scss" scoped>
//the actions container width is 48px;
.attachment-card {
  &__filename {
    width: calc(100% - 48px);
  }

  &__actions {
    width: 48px;
  }
}
</style>
